import axios from 'axios';
import { getAccessToken, isAccessTokenExpired, removeAccessToken } from './token.request';

const api = axios.create({
  baseURL: '/api/oiltrack',
});

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers!.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    return response.config.responseType === 'blob' ? response : response.data;
  },
  async (error) => {
    const status = error.response?.status;

    // Spring Security answers an unauthenticated request with 403, not 401, so a dead
    // session used to surface as a generic error and the sign-in redirect never fired.
    // A 403 while holding a live token means "not allowed", not "not signed in" - that
    // one is left for the caller to report rather than silently logging the user out.
    const sessionEnded = status === 401 || (status === 403 && isAccessTokenExpired());

    if (sessionEnded) {
      removeAccessToken();
      const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/sign-in?returnUrl=${returnUrl}`;
    }
    return Promise.reject(error);
  },
);

export default api;
